module.exports = __webpack_public_path__ + "static/media/Home_welcome.d170d8ad.png";